module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAP9JREFUSEvtldENwjAMRM8bMAKjwAYwAWyC2KQbwAYwCmzABgZLTWWhOL2SqoDU/rQfdl5q+3yCiR+ZmAcaqKoLAHsA9vbPDcBZRB7M5YcATwA2waFXEVmPDdTSgSJCXZ4KMpCqzkCqWlTQt0p6AbAKBsdksR17Sk1/Jovla4YO7eFHAKa/ZnQd+tuniWWl4HOzPSxslZTr/zBXyXD7RMDSVmFaZTHZ7RMBk8gbAHeW0MZZj3f2nSt5EfhJj7yEfgv4Nih+KCj7YfO7kqpqlf2w+R5Y5Qasm8zAToJ9EvmLklbZj6pS+X5ovP34bUbZT6vDZF9hPu34A/dpGD458AmX8qcdEf4zdgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_sys.png
// module id = Y5i1
// module chunks = 1